export default "__VITE_ASSET__BzZmmMEt__"